export default {
    name: 'swipeservice',
    callable() {
        let xStart = null;
        let yStart = null;
        const threshold = 50;

        function addListeners(ele) {
            ele.addEventListener('touchstart', handleTouchStart);
            ele.addEventListener('touchmove', handleTouchMove);
        }

        function removeListeners(ele) {
            ele.removeEventListener('touchstart', handleTouchStart);
            ele.removeEventListener('touchmove', handleTouchMove);
        }

        function handleTouchStart(e) {
            if (e.touches.length !== 1) {
                return; // dismiss two finger touches
            }
            xStart = e.touches[0].pageX;
            yStart = e.touches[0].pageY;
        }

        function handleTouchMove(e) {
            if (!xStart || !yStart) {
                return;
            }
            if (e.touches.length !== 1) {
                resetStartPoint();
                return; // dismiss two finger touches
            }

            const xEnd = e.touches[0].pageX;
            const yEnd = e.touches[0].pageY;

            const xDiff = xStart - xEnd;
            const yDiff = yStart - yEnd;

            if (Math.abs(xDiff) > Math.abs(yDiff)) {
                if (Math.abs(xDiff) > 5) {
                    // Prevent scrolling from happening at the same time as a swipe
                    e.preventDefault();
                }

                if (Math.abs(xDiff) < threshold) {
                    return;
                }

                if (xDiff > 0) {
                    sendEvent('swipeleft', e.target);
                } else {
                    sendEvent('swiperight', e.target);
                }
            }
        }

        function sendEvent(eventName, ele) {
            const event = document.createEvent('Event');
            event.initEvent(eventName, true, true);
            ele.dispatchEvent(event);
            resetStartPoint();
        }

        function resetStartPoint() {
            xStart = null;
            yStart = null;
        }

        return {
            addListeners,
            removeListeners,
        };
    },
};



// WEBPACK FOOTER //
// ./services/swipeservice.js